<!-- eslint-disable vue/singleline-html-element-content-newline -->
<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div class="query">
    <!--查询区域-->
    <div
      v-if="showTop"
      id="top-body"
      :style="{ marginTop: props.mainTop }"
      class="query-form-body"
    >
      <div class="query-container">
        <!-- 左侧查询条件区域（可滚动） -->
        <div class="query-conditions-wrapper">
          <el-scrollbar
            class="query-conditions-scroll"
            :class="{ expanded: isAll }"
            :style="{ maxHeight: isAll ? '105px' : '45px' }"
          >
            <div class="query-conditions">
              <el-form
                ref="queryForm"
                inline
                :model="queryData"
                label-width="93px"
              >
                <!--搜索条件插槽-->
                <slot name="form" />
              </el-form>
            </div>
          </el-scrollbar>
        </div>

        <!-- 右侧按钮区域（所有按钮都在这里，固定位置） -->
        <div class="query-buttons">
          <el-button
            v-if="props.showQueryBut"
            style="font-family: 'webfont'; background: #3ea88d; color: white"
            icon="search"
            @click="query"
          >
            搜 索
          </el-button>
          <el-button
            v-if="props.showResetBut"
            style="font-family: 'webfont'"
            icon="refresh"
            @click="reset"
          >
            重 置
          </el-button>
          <el-link
            v-if="isShow && !isAll"
            type="warning"
            class="more-button"
            @click="isAll = true"
          >
            更 多
            <i class="el-icon-arrow-down el-icon--right" />
          </el-link>
          <el-link
            v-if="isShow && isAll"
            type="warning"
            class="more-button"
            @click="isAll = false"
          >
            收 起
            <i class="el-icon-arrow-up el-icon--right" />
          </el-link>
        </div>
      </div>
    </div>
    <!--按钮插槽-->
    <div id="buts">
      <slot name="buts" class="but-list-body" />
    </div>
    <!--表格插槽-->
    <div id="tableBody" class="table-body">
      <el-table
        v-loading="queryData.loading"
        class="table-list"
        :data="queryData.list"
        row-key="id"
        stripe
        border
        element-loading-text="加载中..."
        :span-method="spanMethod"
      >
        <el-table-column
          v-if="indexVisible"
          type="index"
          label="序号"
          align="center"
          width="80"
        />
        <slot name="table" />
        <el-table-column
          v-if="orgVisible"
          label="所属机构"
          prop="orgName"
          align="center"
          min-width="200"
        />
      </el-table>
      <!-- 分页 - 固定在底部 -->
      <div class="pagination-footer">
        <pagination
          v-if="showPagination"
          v-model:page="queryData.page"
          v-model:limit="queryData.pageSize"
          :total="queryData.total"
          @pagination="queryPagination"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted, nextTick } from 'vue';

//申明emit事件
const emits = defineEmits(['update:modelValue', 'query', 'reset']),
  //接受父组件传入参数
  props = defineProps({
    modelValue: {
      type: Object,
      default: null
    },
    /** 显示头部 */
    showTop: {
      type: Boolean,
      default: true
    },
    /** 显示分页 */
    showPagination: {
      type: Boolean,
      default: true
    },
    /** 分页位置 left right center */
    paginationAlign: {
      type: String,
      default: 'center'
    },
    /** 显示查询按钮 */
    showQueryBut: {
      type: Boolean,
      default: true
    },
    /** 显示重置按钮 */
    showResetBut: {
      type: Boolean,
      default: true
    },
    mainTop: {
      type: String,
      default: '0px'
    },
    //是否显示排序
    indexVisible: {
      type: Boolean,
      default: true
    },
    //是否显示机构名称
    orgVisible: {
      type: Boolean,
      default: false
    },
    //合并行或合并列
    spanMethod: {
      type: Object,
      default: null
    }
  });

//申明响应式参数
let queryData = reactive(props.modelValue),
  isAll = ref(false),
  isShow = ref(false);

// eslint-disable-next-line one-var
const checkIfNeedMoreButton = () => {
    const formElement = document.querySelector('.query-conditions .el-form');

    if (formElement) {
      // 检查表单的实际高度
      const formHeight = formElement.scrollHeight;
      // 如果高度超过一行的高度（大约45px），则显示更多按钮
      // 这里设置一个阈值，因为可能有padding等影响

      isShow.value = formHeight > 50;
    }
  },
  //查询
  query = () => {
    emits('query');
  },
  //页码改变
  queryPagination = (data) => {
    emits('query');
  },
  //重置
  reset = () => {
    queryData.queryEntity = {};
    queryData.page = 1;
    queryData.dateTimeRange = null;
    queryData.pageSize = 10;
    queryData.total = 0;
    queryData.adminCode = null;
    queryData.orgCode = null;
    emits('reset');
  };

//监听函数
watch(
  () => queryData,
  (newValue) => {
    emits('update:modelValue', newValue);
  },
  {
    immediate: true, //watch会在创建后立即执行一次
    deep: true //监听深度嵌套的对象属性
  }
);

// 监听表单内容变化，检查是否需要显示更多按钮
watch(
  () => queryData,
  () => {
    nextTick(() => {
      checkIfNeedMoreButton();
    });
  },
  { deep: true }
);

onMounted(() => {
  // 初始化检查是否需要更多按钮
  nextTick(() => {
    checkIfNeedMoreButton();
  });
});
</script>

<style lang="scss" scoped>
.query {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: column;
}

/**查询区域*/
.query-form-body {
  margin-bottom: 5px;
  padding: 8px;
  width: calc(100% - 16px);
  background-color: #ffffff;
}

.query-container {
  display: flex;
  gap: 10px; /* 左右区域间隔10px */
  align-items: flex-start;
}

/* 左侧查询条件区域容器 */
.query-conditions-wrapper {
  flex: 1;
  position: relative;
  min-height: 45px;
}

/* 查询条件滚动区域 */
.query-conditions-scroll {
  border-radius: 4px;
  background-color: #fff;

  &.expanded {
    max-height: 135px !important; /* 展开时最大高度3行 */
    overflow-x: hidden;
    overflow-y: auto;
  }

  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
  }

  :deep(.el-form-item) {
    margin-bottom: 10px;
    margin-right: 10px;
    font-weight: bold;

    &:last-child {
      margin-right: 0;
    }
  }
}

.query-conditions {
  padding: 10px;
  min-height: 43px; /* 确保最小高度为一行 */
}

/* 右侧按钮区域 - 所有按钮都在这里，固定在第一行 */
.query-buttons {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 45px; /* 固定高度，与查询条件行高一致 */
}

/* 更多/收起按钮样式 */
.more-button {
  margin-left: 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

/* 按钮区域 */
.but-list-body {
  padding: 5px 5px;
  width: 100%;
  border: 1px solid #ebeef5;
}

/* 表格区域 */
.table-body {
  margin-top: 5px;
  flex: 1;
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

//列表区域
.table-list {
  width: 100%;
  flex: 1;
  overflow: auto;
}

/* 分页区域 - 固定在容器底部 */
.pagination-footer {
  flex-shrink: 0; /* 防止被压缩 */
  padding: 10px 0; /* 上下内边距 */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
